/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': 'アクション',
  'ai-smart-button.ai-actions.give-feedback-action.title': 'フィードバックを送信',
  'ai-smart-button.ai-actions.help.section.text': 'ヘルプ',
  'ai-smart-button.ai-actions.input.link-picker-button-label': 'リンク',
  'ai-smart-button.ai-actions.input.mention-button-label': 'メンション',
  'ai-smart-button.ai-actions.input.send-button-label': '送信',
  'ai-smart-button.ai-actions.item.betaLozenge': 'ベータ版',
  'ai-smart-button.ai-actions.item.newLozenge': 'NEW',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': 'アイコンを追加',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': '自動化アイコン',
  'ai-smart-button.ai-actions.rovo-agents.automations.text': '自動化',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'エージェントを見る',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': '自動化を作成',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'スタジオ',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': '{name} さん、',
  'ai-smart-button.ai-proactive-nudge.dismiss': '閉じる',
  'ai-smart-button.feedback-action.ask-question-option': '質問してください',
  'ai-smart-button.feedback-action.cancel-button-label': 'キャンセル',
  'ai-smart-button.feedback-action.choose-feedback-option': '1 つ選択',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'バグまたは課題の説明をご入力ください。',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': '具体的な内容をご入力ください。',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': 'ご質問を教えてください',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': '改良を希望する点をご入力ください。',
  'ai-smart-button.feedback-action.feedback-modal-heading': 'ご意見をお聞かせください',
  'ai-smart-button.feedback-action.leave-comment-option': 'コメントを残す',
  'ai-smart-button.feedback-action.report-bug-option': 'バグを報告する',
  'ai-smart-button.feedback-action.research-participation-message': '製品調査に参加する',
  'ai-smart-button.feedback-action.select-feedback-heading': 'フィードバックを選択してください',
  'ai-smart-button.feedback-action.submit-button-label': 'フィードバックを送信',
  'ai-smart-button.feedback-action.suggest-improvement-option': '改良点を提案する',
  'ai-smart-button.feedback-action.title': 'フィードバックを送信',
  'ai-smart-button.feedback-item.icon-label': 'フィードバック アイコン',
  'ai-smart-button.reference.close-button-label': '閉じる',
};
